import { Amplify, Auth, API } from 'aws-amplify'
import awsconfig from '../../aws-exports'

Amplify.configure(awsconfig)

export async function listUsers() {
  let nextToken
  let getMoreUsers = true
  const userList = []
  const apiName = 'AdminQueries'
  const path = '/listUsers'
  const myInit = {
    queryStringParameters: {
      groupname: 'AllUsers',
      token: nextToken,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
    },
  }

  /* API will cycle until NextToken is undefined */
  while (getMoreUsers === true) {
    // eslint-disable-next-line no-await-in-loop
    const { NextToken, ...rest } = await API.get(apiName, path, myInit)
    userList.push(rest.Users)
    myInit.queryStringParameters.token = NextToken
    if (NextToken === undefined) getMoreUsers = false
  }
  return userList.flat(1)
}

// Delete A User
export async function adminDisableUser(disabledUser) {
  const apiName = 'AdminQueries'
  const path = '/disableUser'
  const myInit = {
    body: {
      username: disabledUser,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
    },
  }
  await API.post(apiName, path, myInit)
}

// Create A User - Admin Only
export async function adminCreateUser(formData, warehouseCode) {
  const apiName = 'AdminQueries'
  const path = '/createUser'
  const request = {
    body: {
      username: formData.username,
      password: formData.pw,
      email: formData.email,
      website: formData.website,
      clientName: formData.clientName,
      clientCode: formData.clientCode,
      whse_code: warehouseCode,
      dms: formData.dms,
      clientRole: formData.userType,
      invitedBy: formData.invitedBy,
      dmsdb: formData.dmsdb,
      wmsdb: formData.wmsdb,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
    },
  }
  await API.post(apiName, path, request)
}

// Get List of Admins
let nextToken
export async function listAdmins() {
  const apiName = 'AdminQueries'
  const path = '/listUsersInGroup'
  const myInit = {
    queryStringParameters: {
      groupname: 'AdminGroup',
      token: nextToken,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
    },
  }
  const { NextToken, ...rest } = await API.get(apiName, path, myInit)
  nextToken = NextToken
  return rest
}
